<template>
	<div>
		<el-breadcrumb separator="/" class="breadcrumb">
			<el-breadcrumb-item :to="{ path: '/setting/customer' }">{{ $t("customerProductLastest.myClient") }}</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: `/setting/customer-product/${customerId}` }">{{
				$t("customerProductLastest.productSettings")
			}}</el-breadcrumb-item>
			<el-breadcrumb-item>{{ $t("customerProductLastest.syncSettings") }}</el-breadcrumb-item>
		</el-breadcrumb>
		<el-button size="mini" @click="handleProductsCheckUpdate">{{ $t("customerProductLastest.changeUpdates") }}</el-button>
		<el-table :data="productLastest" style="width: 100%" v-loading="loading">
			<el-table-column prop="product.level5" label="Level5 Code" width="150"> </el-table-column>
			<el-table-column prop="old_value.name" :label="'Level5 Text(' + this.$t('customerProductLastest.old') + ')'"> </el-table-column>
			<el-table-column prop="new_value.name" :label="'Level5 Text(' + this.$t('customerProductLastest.new') + ')'"> </el-table-column>
			<el-table-column
				prop="status"
				:label="this.$t('customerProductLastest.state')"
				:filters="[
					{ text: this.$t('customerProductLastest.waitingForConfirmation'), value: 0 },
					{ text: this.$t('customerProductLastest.applied'), value: 1 },
					{ text: this.$t('customerProductLastest.notApplied'), value: 2 },
				]"
				:filter-method="filterStatus"
				:filter-dropdown="{ confirmButtonText: '123' }"
			>
				<template slot-scope="scope">
					<span>{{
						scope.row.status === 0
							? $t("customerProductLastest.waitingForConfirmation")
							: scope.row.status === 1
							? $t("customerProductLastest.applied")
							: $t("customerProductLastest.notApplied")
					}}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="operate"
				:label="this.$t('customerProductLastest.operate')"
				:filters="[
					{ text: this.$t('customerProductLastest.newAdditions'), value: 'create' },
					{ text: this.$t('customerProductLastest.renew'), value: 'update' },
				]"
				:filter-method="filterOperate"
			>
				<template slot-scope="scope">
					<span>{{ scope.row.operate == "create" ? $t("customerProductLastest.newAdditions") : $t("customerProductLastest.renew") }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="updated_at" :label="this.$t('customerProductLastest.time')"> </el-table-column>
			<el-table-column prop="cz" :label="this.$t('customerProductLastest.SALESConfirmed')"
				>>
				<template slot-scope="scope">
					<el-button size="mini" @click="handleApplySumbit(scope.row.product.id, scope.$index)" type="primary" plain>{{
						$t("customerProductLastest.application")
					}}</el-button>
					<el-button size="mini" @click="handleAbortSumbit(scope.row.product.id, scope.$index)" :type="switchStatus(scope.row.status)" plain>{{
						$t("customerProductLastest.notApplied")
					}}</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
import { getCustomerPorductLastest, postCustomerApplyProductLastest, postCustomerAbortProductLastest, postProductsCheckUpdate } from "@/services/api-v2/api-v2";
export default {
	name: "customerProductLastest",

	data() {
		return {
			// 客户id
			customerId: "",

			// 加载动画
			loading: false,

			// 商品设置数据
			productLastest: [],
		};
	},
	created() {
		this.customerId = this.$route.params.id;
		this.initCustomerProductLastest();
	},
	methods: {
		// 初始化数据
		async initCustomerProductLastest() {
			this.loading = true;
			try {
				const { data } = await getCustomerPorductLastest(this.customerId);
				this.productLastest = data;
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},

		// 操作筛选
		filterOperate(value, row) {
			return row.operate === value;
		},

		// 类别筛选
		filterStatus(value, row) {
			return row.status === value;
		},

		//不应用时切换type类型显示灰底
		switchStatus(status) {
			return status === 2 ? "info" : "warning";
		},

		//检查商品变动更新点击事件
		async handleProductsCheckUpdate() {
			this.loading = true;
			try {
				await postProductsCheckUpdate(this.customerId);
				this.initCustomerProductLastest();
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},

		// 应用点击事件
		async handleApplySumbit(productId, index) {
			try {
				await postCustomerApplyProductLastest(this.customerId, productId);
				this.productLastest[index].status = 1;
				this.$message.success(this.$t("customerProductLastest.successfulOperation"));
			} catch (error) {
				this.$message.error(error);
			}
		},

		// 不应用点击事件
		async handleAbortSumbit(productId, index) {
			try {
				await postCustomerAbortProductLastest(this.customerId, productId);
				this.productLastest[index].status = 2;
				this.$message.success(this.$t("customerProductLastest.successfulOperation"));
			} catch (error) {
				this.$message.error(error);
			}
		},
	},
};
</script>

<style scoped>
.breadcrumb {
	margin-bottom: 20px;
}
</style>
